/* eslint-disable no-unused-vars */

import React from "react";
import { withRouter } from 'react-router';
import { CommonHelper, ToastHelper } from 'components/Common/Helper/Helper';
import classNames from 'classnames';

import * as microsoftTeams from "@microsoft/teams-js";

import { Flex, Segment, Text, Loader, CallPstnIcon, } from '@fluentui/react-northstar'

import { TeamsContext, teamsTabStyles, TabNavBar } from "libs/teams-tab";

import EnhancedTabs from 'components/Common/EnhancedTabs/EnhancedTabs';

// reactstrap components
import { Container, Row, Col } from "reactstrap";

import { QuestionsList } from './QuestionsList';

let myContext = null;

class Survey extends React.Component {
  constructor(props) {
    super();

    this.state = {
      loading: true,
      error: null,
      id: null,
      callId: null,
      data: null,
    };
  }

  componentDidMount() {
    let id, callId = null;

    if (this.props.match.params) {
      if (this.props.match.params.id) {
        id = this.props.match.params.id;
      }
      if (this.props.match.params.callId) {
        callId = this.props.match.params.callId;
      }
    }

    this.setState({ id, callId }, this.getSurvey);
  }

  componentDidUpdate(prevProps) {
    if (!CommonHelper.AreEquals(this.props, prevProps)) {
    }
  }

  componentWillMount() {
  }

  getSurvey = () => {
    const { id, callId } = this.state;
    if (id && callId) {
      this.setState({ loading: true }, async () => {

        const filter = { id };
        const expand = `surveyquestions($expand=surveyanswers),callsurveyactivities($filter=callId eq ${callId};$expand=surveyteammemberanswers) `;
        let result = await myContext.dataProviders.api.getList('surveys', { filter, expand });

        if (result && result.data.length > 0) {
          this.setState({ loading: false, data: result.data[0] });
          return;
        }
        else {
          ToastHelper.Error(`Impossibile recuperare il sondaggio con id '${id}'`);
          this.setState({ loading: false, data: null });
        }
      });
    }
    else {
      ToastHelper.Error('Id del sondaggio e/o della riunione mancanti');
      this.setState({ loading: false, data: null });
    }
  }

  selectQuestion = async (question) => {
    const { callId } = this.state;
    const { teamChannel, dataProviders } = myContext;

    let result = await dataProviders.bot.create(`sendQuestionToLesson/${callId}/${question.id}`, { addMsToken: true, teamChannelId: teamChannel.id });

    if (result && result.data && result.data.success) {
      setTimeout(() => {
        microsoftTeams.tasks.submitTask(null);
      }, 2000);
    }
    else {
      ToastHelper.Error("Errore durante l'invio della domanda");
    }
  };

  render() {
    const { loading, data, id } = this.state;
    
    return (
      <TeamsContext.Consumer>
        {context => {
          myContext = context;

          return (
            <>
              <TabNavBar
                title={<><Text content="Sondaggio" /> {data && <Text content={data.title} weight="bold" size="large" />}</>}
                icon={<CallPstnIcon size="large" />}
              />
              <Flex.Item>
                <Segment styles={teamsTabStyles.content}>
                  {
                    !myContext || !myContext.msTeamsContext || loading ?
                      <Loader label="Caricamento..." /> :
                      <Container fluid>
                        <Row>
                          <Col className="p-0">
                            {
                              data.surveyQuestions &&
                              data.surveyQuestions.map((question, key) =>
                                <QuestionsList
                                  key={key}
                                  index={++key}
                                  question={question}
                                  callSurveyActivities={data.callSurveyActivities}
                                  selectQuestion={this.selectQuestion}
                                />
                              )
                            }
                          </Col>
                        </Row>
                      </Container>
                  }
                </Segment>
              </Flex.Item>
            </>
          )
        }}
      </TeamsContext.Consumer>
    )
  }
}

export default withRouter(Survey);